<template>
  <div class="mainAdjust">
    <div class="nav">
      <div class="icon" @click="showTip = true">
        <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
      </div>
      调整球员
    </div>
    <div class="content_wrap">
      <div class="left">
        <div class="title">
          <p style="font-size:18px">球员数据中其他球员</p>
          <p>点击 "+" 添加球员</p>
        </div>
        <div class="select_wrap">
          <div class="search_box">
            <input type="text" v-model="key" @keyup.enter="getFreePlayers" class="yioks_input" placeholder="请输入关键字">
            <div class="yioks_btn" @click="getFreePlayers">搜索</div>
          </div>
        </div>
        <div class="head">
          <el-row>
            <el-col :span="4">照片</el-col>
            <el-col :span="10">姓名</el-col>
            <!-- <el-col :span="8">位置</el-col> -->
            <el-col :span="4" :offset="2">操作</el-col>
          </el-row>
        </div>
        <div class="list_wrap">
          <vue-scroll>
            <div v-for="(item, index) in idlePlayers" :key="index" class="item">
              <el-row>
                <el-col :span="4"><img :src="person" alt=""></el-col>
                <el-col :span="10">{{item.idName}}</el-col>
                <!-- <el-col :span="8">{{item.position ? item.position : '--'}}</el-col> -->
                <el-col :span="4" :offset="2">
                  <el-button
                  type="primary"
                  circle
                  icon="el-icon-plus"
                  size="mini"
                  @click="operaPlayer('add',item, index)"></el-button>
                </el-col>
              </el-row>
            </div>
            <yioks-empty v-if="idlePlayers.length === 0" :h="'325px'"></yioks-empty>
          </vue-scroll>
        </div>
      </div>
       <div class="right">
        <div class="title">
          <div class="name">
            <img src="@/assets/images/common/people.png" alt="">
            球队现有球员
          </div>
          <p>点击 "-" 移出球员</p>
        </div>
        <div class="head">
          <el-row>
            <el-col :span="4">照片</el-col>
            <el-col :span="8">姓名</el-col>
            <el-col :span="8">位置</el-col>
            <el-col :span="4">操作</el-col>
          </el-row>
        </div>
        <div class="list_wrap">
          <vue-scroll>
            <div v-for="(item, index) in squadPlayers" :key="index" class="item">
              <el-row>
                <el-col :span="4"><img :src="person" alt=""></el-col>
                <el-col :span="8">{{item.idName}}</el-col>
                <el-col :span="8">{{item.position ? item.position : '--'}}</el-col>
                <el-col :span="4">
                  <el-button
                  type="danger"
                  circle
                  icon="el-icon-minus"
                  size="mini"
                  @click="operaPlayer('remove',item, index)"></el-button>
                  <!-- @click="operaPlayer('remove',index)"></el-button> -->
                </el-col>
              </el-row>
            </div>
            <yioks-empty v-if="squadPlayers.length === 0" :h="'380px'"></yioks-empty>
          </vue-scroll>
        </div>
      </div>
    </div>
    <div class="btn_wrap">
      <el-button type="primary" style="margin-right: 50px" @click="saveSquad">确定</el-button>
      <el-button type="danger" @click="showTip = true">取消</el-button>
    </div>
    <yioks-tip :showTip="showTip" tipMsg="确定放弃修改并返回吗？" @callback="goBack"></yioks-tip>
    <template v-if="isShowPlayerPosition">
      <el-dialog
        title="请选择球员位置"
        :visible.sync="isShowPlayerPosition"
        width="400px"
        :destroy-on-close='true'
        :before-close="handleClosePositionSelect">
        <div class="position-select-wrapper">
          <el-form ref="positionFormDom" :model="positionForm" label-width="80px">
            <el-form-item label="位置" prop="selectedPosition" :rules="[{required: true, message: '请选择球员位置', trigger: 'change'}]">
              <el-select v-model="positionForm.selectedPosition" placeholder="请选择球员位置" clearable>
                <el-option v-for="item in playerPositionList" :key="item.uuid" :label="item.playerPositionName" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="position-footer">
          <el-button type="primary" @click="handlePositionConfirmed">确 定</el-button>
          <el-button @click="isShowPlayerPosition = false">取 消</el-button>
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>

import 'vue-awesome/icons/regular/arrow-alt-circle-left'
import person from '@/assets/images/common/person.jpg'
import player from '@/api/player'
import storage from '@/utils/storage'
export default {
  data () {
    return {
      person,
      showTip: false,
      squadUuid: this.$route.query.uuid,
      squadPlayers: [],
      idlePlayers: [],
      key: '',
      players: [],
      userRole: storage.get('userInfo').userRole,
      addPlayerUuids: [],
      removePlayerUuids: [],
      playerPositionList: [], // 球员位置列表
      isShowPlayerPosition: false,
      positionForm: {
        selectedPosition: '',
      },
      playerToOperate: {  // 操作（添加/删除）的学员信息
        playerIndex: 0,
        playerInfo: {}
      }
    }
  },
  created () {
    this.loadPlayerPositionList();
    this.getPlayers();
  },
  methods: {
    goBack (isSure) {
      if (isSure) {
        this.$router.go(-1)
      } else {
        this.showTip = false
      }
    },
    /* 获取青训中心球员 */
    getFreePlayers () {
      const _ = require('lodash');
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        //  获取青训中心球员
        request = player.getIdlePlayerBySystem
      } else if (this.userRole === 'organ') {
        request = player.getIdlePlayerByOrg
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = player.getIdlePlayerByYouth
      } else if(this.userRole === 'coach') {
        request = player.getIdlePlayerByCoach
      }
      request({ squadUuid: this.squadUuid, key: this.key }).then(res => {
        // this.idlePlayers = res || []
        // 从全部球员中剔除球队现有成员
        let map =　{};
        let aim = [];
        this.squadPlayers.forEach(item => {
          const { uuid } = item;
          map[uuid] = item;
        })
        res.forEach(item => {
          const { uuid } = item;
          if(!map[uuid]) {
            aim.push(item)
          }
        })
        // const idlePlayersList = _.xorBy(this.squadPlayers, res, 'uuid' );  // 去除res中this.squadPlayers的数据
        this.idlePlayers = aim;
      })
    },
    /* 获取球队成员 */
    getPlayers () {
      player.getSquadPlayer(this.squadUuid).then(res => {
        if (!res.code) {
          this.squadPlayers = res;
          res.forEach(item => {
            this.players.push(item.uuid)
          })

          // 获取青训其他球员
          this.getFreePlayers()
        }
      })
    },
    operaPlayer (type, row, index) {
      if(type === 'add') {
        this.playerToOperate = {
          playerIndex: index,
          playerInfo: row
        }
        this.isShowPlayerPosition = true;
      } else if (type === 'remove') {
        // let removeData = this.squadPlayers.splice(index, 1)[0]
        this.squadPlayers.splice(index, 1); // 从球队现有球员中删除该球员
        const { uuid } = row;
        this.idlePlayers.push(row)
        this.removePlayerUuids.push(uuid)
      }
    },
    // operaPlayer (type, index) {
    //   if (type === 'add') {
    //     let addData = this.idlePlayers.splice(index, 1)[0]
    //     this.squadPlayers.push(addData)
    //     // 说明一下逻辑，当添加球员已经存在球队中（先移除），此时需要删除移除数组中此球员的 uuid，因为他没有被删除
    //     // 如果不存在球队，则添加到 添加数组中
    //     if (this.players.indexOf(addData.uuid) !== -1) {
    //       let idx = this.removePlayerUuids.indexOf(addData.uuid)
    //       this.removePlayerUuids.splice(idx, 1)
    //     } else {
    //       this.addPlayerUuids.push(addData.uuid)
    //     }
    //   } else if (type === 'remove') {
    //     let removeData = this.squadPlayers.splice(index, 1)[0]
    //     this.idlePlayers.push(removeData)
    //     this.removePlayerUuids.push(removeData.uuid)
    //   }
    // },
    saveSquad () {
      let requstData = {
        addPlayerUuids: this.addPlayerUuids,
        removePlayerUuids: this.removePlayerUuids,
        squadUuid: this.squadUuid
      }
      console.log('requstData',requstData)
      player.updataSquadPlayer(requstData).then(res => {
        this.$message.success('调整成功')
        this.$router.go(-1)
      })
    },
    // 获取球员位置可选项
    loadPlayerPositionList() {
      player.allPositionList().then(res => {
        if(res.code) {
          this.$message.error(res.msg);
          return
        }
        this.playerPositionList = res.map(item => {
          const { playerPositionName, id, uuid, ...rest } = item;
          return {
            playerPositionName,
            uuid,
            value: JSON.stringify({playerPositionName, id})
          }
        });
      }).catch(err => {
        console.error('err', err)
      })
    },

    //
    handleClosePositionSelect() {
      this.playerToOperate = {
        playerIndex: 0,
        playerInfo: {}
      }
      this.isShowPlayerPosition = false;
    },
    // 确认选择球员位置
    handlePositionConfirmed() {
      this.$refs.positionFormDom.validate(valid => {
        if(valid) {
          // this.addPlayerUuids = []; // 清空位置信息
          let { playerIndex, playerInfo } = this.playerToOperate;
          this.idlePlayers.splice(playerIndex, 1);  // 删除青训中心的球员信息
          let { id, playerPositionName } = JSON.parse(this.positionForm.selectedPosition);
          this.$set(playerInfo, 'position', playerPositionName)
          this.$set(playerInfo, 'positionId', id)
          this.squadPlayers.push(playerInfo); // 在球队中添加球员
          this.addPlayerUuids.push({
            uuid: playerInfo.uuid,
            positionId: id,
            position: playerPositionName
          })
          this.isShowPlayerPosition = false;  // 关闭弹窗
          this.$set(this.positionForm, 'selectedPosition', '')
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .mainAdjust
    display flex
    flex-direction column
    width 890px
    height 710px
    align-items center
    justify-content space-between
    font-size 16px
    .nav
      color #FFF
      height 60px
      background $black_color
      font-size 18px
      width 100%
      display flex
      align-items center
      box-sizing border-box
      user-select none
      .icon
        padding 0 20px
        cursor pointer
    .content_wrap
      width 100%
      height 560px
      display flex
      .left,.right
        background $black_color
        flex 1
        padding 15px 0 15px 15px
        box-sizing border-box
        color #FFF
        font-size 16px
        display flex
        flex-direction column
        .title
          display flex
          justify-content space-between
          padding-bottom 20px
          border-bottom 1px solid #FFF
          margin-right 15px
          align-items center
          .name
            display flex
            align-items center
            font-size 18px
            img
              margin-right 10px
        .head
          font-weight bold
          padding-bottom 25px
          border-bottom 1px solid #CCC
          margin-right 35px
          color #CCC
          .el-col
            text-align center
        .list_wrap
          flex 1
          overflow hidden
          .item
            padding 10px 0
            border-bottom 1px solid #CCC
            margin-right 35px
            .el-row
              display flex
              align-items center
              .el-col
                display flex
                justify-content center
            img
              width 55px
              height 55px
              /*height .32rem*/
              border-radius 50%
      .left
        margin-right 32px
        .select_wrap
          justify-content center
          margin-right 15px
      .right
        .head
          padding-top 20px
    .btn_wrap
      display flex
      justify-content center


  .position-footer
    display flex
    width 40%
    margin 0 auto
    justify-content space-around
</style>
